import(/* webpackMode: "eager" */ "/home/runner/work/all-inclusive-mono/all-inclusive-mono/apps/web/src/app/[course]/page.tsx");
